"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileViewer = exports.Button = exports.FileUpload = exports.LayoutControlsGridCol = exports.LayoutControlsGridLayout = exports.UploadViewer = void 0;
var React = require("react");
var csod = require("player-core");
var ViewSF_1 = require("./ViewSF");
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
Object.defineProperty(exports, "LayoutControlsGridLayout", { enumerable: true, get: function () { return GridLayout_1.GridLayout; } });
var GridCol_1 = require("player-layout-controls/controls/GridCol");
Object.defineProperty(exports, "LayoutControlsGridCol", { enumerable: true, get: function () { return GridCol_1.GridCol; } });
var player_file_upload_1 = require("player-file-upload");
exports.FileUpload = player_file_upload_1.default;
var player_button_1 = require("player-button");
exports.Button = player_button_1.default;
var player_file_viewer_1 = require("player-file-viewer");
exports.FileViewer = player_file_viewer_1.default;
var UploadViewer = (function (_super) {
    __extends(UploadViewer, _super);
    function UploadViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.packageName = 'player-application-workflow';
        _this._renderView = _this._renderView.bind(_this);
        _this.viewSF = ViewSF_1.viewSF.apply(_this);
        _this.viewSF.constructor && _this.viewSF.constructor.apply(_this, arguments);
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    UploadViewer.prototype.componentDidMount = function () {
        this.viewSF.mounted && this.viewSF.mounted.apply(this, arguments);
    };
    UploadViewer.prototype.componentWillReceiveProps = function (nextProps) {
        this.viewSF.willReceiveProps && this.viewSF.willReceiveProps.apply(this, arguments);
    };
    UploadViewer.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.viewSF.shouldUpdate)
            return this.viewSF.shouldUpdate.apply(this, arguments);
        else
            return true;
    };
    UploadViewer.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.viewSF.didUpdate && this.viewSF.didUpdate.apply(this, arguments);
    };
    UploadViewer.prototype.componentWillUnmount = function () {
        this.viewSF.unmount && this.viewSF.unmount.apply(this, arguments);
    };
    UploadViewer.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._processEvent(eventName, args, 4, monikerCallback);
    };
    UploadViewer.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._processEvent(eventName, args, 2, function () { });
    };
    UploadViewer.prototype._processEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.viewSF.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                self_1.viewSF.events[eventName].apply(self_1, combinedArgs);
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    UploadViewer.prototype._renderView = function () {
        var _this = this;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var root_handler = function () {
            return [
                React.createElement(GridLayout_1.GridLayout, { key: 0, children: [
                        React.createElement(GridCol_1.GridCol, { key: 0, width: "12", widthForSm: "6", widthForMd: "4", isVisible: _this.props.showUpload, children: [
                                React.createElement(player_file_upload_1.default, { key: 0, id: (_this.state.hasOwnProperty('fileUploadId') ? _this.state.fileUploadId : _this.props.fileUploadId), tag: (_this.state.hasOwnProperty('fileUploadId') ? _this.state.fileUploadId : _this.props.fileUploadId), name: (_this.state.hasOwnProperty('fileUploadId') ? _this.state.fileUploadId : _this.props.fileUploadId), errorMessage: (_this.state.hasOwnProperty('fileUploadError') ? _this.state.fileUploadError : _this.props.fileUploadError), accept: (_this.state.hasOwnProperty('accept') ? _this.state.accept : _this.props.accept), isEnabled: (_this.state.hasOwnProperty('fileUploadIsEnabled') ? _this.state.fileUploadIsEnabled : _this.props.fileUploadIsEnabled), ariaLabel: (_this.state.hasOwnProperty('ariaLabel') ? _this.state.ariaLabel : _this.props.ariaLabel), ariaLabelledBy: (_this.state.hasOwnProperty('ariaLabelledBy') ? _this.state.ariaLabelledBy : _this.props.ariaLabelledBy), onChange: _this._proxyEvent("uploadFile"), children: [
                                        React.createElement(player_button_1.default, { key: 0, text: (_this.state.hasOwnProperty('fileUploadText') ? _this.state.fileUploadText : _this.props.fileUploadText), color: "Grey", iconName: "up-arrow-bar", width: (_this.state.hasOwnProperty('fileUploadWidth') ? _this.state.fileUploadWidth : _this.props.fileUploadWidth), useSpanElement: true, isDisabled: false, ariaDescribedBy: "resumeFileUpload-error" })
                                    ] })
                            ] }),
                        React.createElement(GridCol_1.GridCol, { key: 1, width: "12", widthForSm: "6", isVisible: !_this.props.showUpload, children: [
                                React.createElement(player_file_viewer_1.default, { key: 0, deleteIconLabel: (_this.state.hasOwnProperty('fileDeleteMessage') ? _this.state.fileDeleteMessage : _this.props.fileDeleteMessage), fileName: (_this.state.hasOwnProperty('fileName') ? _this.state.fileName : _this.props.fileName), fileSize: (_this.state.hasOwnProperty('fileSize') ? _this.state.fileSize : _this.props.fileSize), fileUrl: (_this.state.hasOwnProperty('fileUrl') ? _this.state.fileUrl : _this.props.fileUrl), fileIconName: (_this.state.hasOwnProperty('fileIconName') ? _this.state.fileIconName : _this.props.fileIconName), fileIconBackgroundColor: (_this.state.hasOwnProperty('fileIconBackgroundColor') ? _this.state.fileIconBackgroundColor : _this.props.fileIconBackgroundColor), tag: (_this.state.hasOwnProperty('fileViewerId') ? _this.state.fileViewerId : _this.props.fileViewerId), brandIconName: (_this.state.hasOwnProperty('brandIconName') ? _this.state.brandIconName : _this.props.brandIconName), handleDeleteButtonClick: _this._proxyEvent("onDelete") })
                            ] })
                    ] })
            ];
        };
        return root_handler();
    };
    UploadViewer.prototype.render = function () {
        return (React.createElement("div", { className: "p-viewSF-uploadviewer" }, this._renderView()));
    };
    UploadViewer.defaultProps = {
        accept: [], sizeLimit: 0, fileUploadError: '', fileUploadId: '', fileUploadText: '', fileUploadWidth: '', fileViewerId: '', fileName: '', fileUrl: '', fileIconName: '', fileIconBackgroundColor: '', fileSize: '', guid: '', maxFileNameLength: 50, showUpload: true, fileSizeErrorMessage: '', fileDeleteMessage: '', fileNameLengthErrorMessage: '', fileTypeErrorMessage: '', parsingResumeText: '', brandIconName: 'None', fileUploadIsEnabled: true, ariaLabel: '', ariaLabelledBy: '',
        onSuccess: function () { }, onError: function () { }, onDelete: function () { }, onLoadingChanged: function () { }, onChangeSpinnerText: function () { }
    };
    return UploadViewer;
}(React.Component));
exports.UploadViewer = UploadViewer;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["UploadViewer"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/UploadViewer/UploadViewer.js
// module id = 79
// module chunks = 0 2